import React, { useState } from "react";
import IconSvg from "./IconSvg";
import "./style.css";
import { skillActivities } from "../../../utils/constants/SkillsActivities";

const CoreSkillsAssessmentSection = ({ data, onViewStudents }) => {
  const { skills, insight } = data;
  const [skillModalOpen, setSkillModalOpen] = useState(null);

  const handleModal = (skill) => {
    const skill_data = skillActivities.find(
      (activity) => activity.title === skill
    );
    setSkillModalOpen(skill_data);
  };
  // console.log("skill", skillModalOpen)
  const getScoreBadgeClass = (score) => {
    if (score >= 70) return "bg-green-100 text-green-800";
    if (score >= 40) return "bg-yellow-100 text-yellow-800";
    return "bg-red-100 text-red-800";
  };
  const filter_bottom_five = (skills || [])
    .filter((skill) => skill.batchAvgScore < 65)
    .sort((a, b) => a.batchAvgScore - b.batchAvgScore)
    .slice(0, 5);
  const remaining_skills = (skills || []).filter(
    (skill) =>
      !filter_bottom_five.some((bottomSkill) => bottomSkill.name === skill.name)
  );

  return (
    <section className="mb-6">
      <h2 className="section-heading">
        <IconSvg
          path="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          className="h-5 w-5 mr-2 text-primary-600"
        />
        Core Skills Assessment
        <div className="tooltip-wrapper">
          <IconSvg
            path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            className="h-4 w-4 text-gray-400"
          />
          <div className="tooltip-content w-64">
            Analysis of 5 key skills from the 15 skills we assess. These core
            skills can be improved with proper intervention.
          </div>
        </div>
      </h2>

      {/* Core Skills Assessment Card */}
      <div className="card p-4">
        <p className="text-sm text-gray-600 mb-4">
          Out of the 15 skills we assess in the CEE, these core skills have been
          identified as high-impact areas where targeted interventions by the
          college can lead to significant improvements in student employability.
        </p>

        {filter_bottom_five.length > 0 && (
          <div className="skills-table-container">
            <table className="skills-table">
              <thead>
                <tr>
                  <th scope="col">Skill</th>
                  <th scope="col">Description</th>
                  <th scope="col">Batch Avg Score</th>
                  <th scope="col">
                    <div className="flex items-center">
                      <span>Poor Performers</span>
                      <div className="tooltip-wrapper">
                        <IconSvg
                          path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          className="tooltip-icon"
                        />
                        <div className="tooltip-content-skills w-48">
                          Students scoring below 50% in this skill
                        </div>
                      </div>
                    </div>
                  </th>
                  <th scope="col" style={{ textAlign: "right" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {filter_bottom_five.map((skill) => (
                  <tr key={skill.name}>
                    <td>
                      <div className="flex items-center">
                        <div className={`skill-icon-wrapper ${skill.iconBg}`}>
                          <IconSvg
                            path={skill.iconPath}
                            className={`h-4 w-4 ${skill.iconColor}`}
                          />
                        </div>
                        <div className="ml-3">
                          <span className="text-sm font-medium text-gray-900">
                            {skill.name}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="text-sm text-gray-500">
                        {skill.description}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`skill-score-badge ${getScoreBadgeClass(
                          skill.batchAvgScore
                        )}`}
                      >
                        {skill.batchAvgScore}%
                      </span>
                    </td>
                    <td>
                      <span className="skill-poor-performers-count">
                        {skill.poorPerformersCount} students
                      </span>
                    </td>
                    <td>
                      <button
                        onClick={() => onViewStudents()}
                        className="skill-view-button"
                      >
                        View Students
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <span className="pt-3 text-sm text-gray-600">
          <span className="font-medium text-indigo-600">Action Required:</span>{" "}
          Click here to read about some innovative ways to improve{" "}
          {filter_bottom_five.map((skill, index) => (
            <button
              key={skill.name}
              onClick={() => handleModal(skill.name)}
              style={{
                textDecoration: "underline",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "0 0.25rem",
                color: "#3b82f6",
              }}
            >
              {skill.name}
              {index < remaining_skills.length - 1 ? "," : ""}
            </button>
          ))}{" "}
          of the batch.
        </span>
      </div>

      {skillModalOpen && (
        <div className="modal-overlay" onClick={() => setSkillModalOpen(null)}>
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-body">
              <div className="modal-border flex justify-between items-center w-full mb-4">
                <h2 className="text-xl font-semibold">
                  {skillModalOpen.title}
                </h2>
                <button
                  style={{ marginTop: "-16px" }}
                  onClick={() => setSkillModalOpen(null)}
                  className="modal-close-button"
                >
                  <IconSvg path="M6 18L18 6M6 6l12 12" className="h-6 w-6" />
                </button>
              </div>
              {skillModalOpen.activities.map((activity, index) => (
                <div key={index} className="mb-3">
                  <p className="text-sm text-gray-700">
                    {index + 1}.{" "}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: activity,
                      }}
                    ></span>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CoreSkillsAssessmentSection;
